/** @module Parsing of server timestamps so they display in the viewer's own timezone. */

/** Matches D1 `CURRENT_TIMESTAMP` text (`YYYY-MM-DD HH:MM:SS`, optionally with fractions), which is UTC without a zone marker. */
const D1_TIMESTAMP = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?$/;

/**
 * Parse a server timestamp into a `Date`.
 *
 * D1 stores times as UTC text without a zone (`2026-10-14 20:00:00`), and
 * browsers read that shape as *local* time, which shifts every displayed time
 * by the viewer's UTC offset. Zoneless D1 text is therefore read as UTC; ISO
 * strings that carry `Z` or an offset are parsed as given. Formatting the
 * returned `Date` with the usual date-fns or `toLocale*` helpers then shows the
 * viewer's local time.
 */
export function parseServerTime(value: string): Date {
  const text = value.trim();
  return new Date(D1_TIMESTAMP.test(text) ? `${text.replace(' ', 'T')}Z` : text);
}
